module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/featured1.jpg";